import { scaleLinear } from "d3-scale";
export const colorByVariable = {
  price: ["#35b462", "#fff45a", "#e14a47"],
  regulation: ["#49d3ff", "#af6ab1", "#3e7ad3"],
  tax: ["#fff45a", "#35b462"],
  carbon: ["#fffcd9", "#35b462", "#2242b9"],
  subregion: ["#fff", "#4a79bc"],
};

export function setColorByValue(data, minmax, variable) {
  let result = [];
  let colors = colorByVariable[variable];
  let tempCountries = [...data];
  let [min, max] = minmax;
  let range =
    variable === "price" || variable === "carbon"
      ? [min, (max - min) / 2 + min, max]
      : [min, max];
  let scale = scaleLinear(range, colors);
  let selector = variable === "subregion" ? "sub_id" : "ISO3";
  tempCountries.forEach((row) => {
    let color = scale(variable === "subregion" ? row.diff : row.value);
    result.push(["match", ["get", selector], [row[selector]], true, false]);
    result.push(color);
  });
  result.splice(0, 0, "case");
  result.splice(result.length * 2 + 1, 0, "#fff");
  return result;
}

export function setColorByCategory(data) {
  const regions = (d) => data.filter((e) => e.value === d).map((e) => e.ISO3);
  return [
    "interpolate",
    ["linear"],
    ["zoom"],
    2,
    [
      "case",
      ["match", ["get", "ISO3"], regions(1), true, false],
      colorByVariable.regulation[0],
      ["match", ["get", "ISO3"], regions(2), true, false],
      colorByVariable.regulation[1],
      ["match", ["get", "ISO3"], regions(3), true, false],
      colorByVariable.regulation[2],
      "#fff",
    ],
    2.3,
    "#fff",
  ];
}
